import { createContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import FusePageCarded from "@fuse/core/FusePageCarded/FusePageCarded";
import DetailSidebarContent from "./DetailSidebarContent";
import { useThemeMediaQuery } from "@fuse/hooks";
import FileList from "./FilesList";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
const FileFolderContext = createContext();
const PathBreadCrumbContext = createContext();
const DeleteFileFolderContext = createContext();

const HrPolicies = () => {
    const [selectedFileFolder, setSelectedFileFolder] = useState();
    const [deletedFileFolder, setDeletedFileFolder] = useState();
    const [pathBreadCrumb, setPathBreadCrumb] = useState([{ id: '', name: 'All' }]);
    const routeParams = useParams();
    const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
    const [folders, setFolders] = useState([])
    const [files, setFiles] = useState([])
    const libraryUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.libraryStructure}`;

    const getAllList = async () => {
        try {
            const alllist = await OAuthService.getList(libraryUrl + '/getLibraryStructure');
            if (alllist?.data) {
                setFolders(alllist?.data);
                setFiles([]);
                let currentFolder = null;
                let newPath = [...pathBreadCrumb]
                currentFolder =  0;
                if (currentFolder >= 0) {
                    newPath = newPath.slice(0, currentFolder + 1);
                }
                setPathBreadCrumb(newPath)
            } else {
                setFiles([]);
                setFolders([]);
            }
        } catch (error) {

        }

    }
    const getFilteredList = async () => {
        try {
            const alllist = await OAuthService.getList(libraryUrl + '/findChild/' + routeParams.id);
            if (alllist?.data) {
                alllist?.data.map((data) => {
                    if (data?.subFolder) {
                        setFolders(data?.subFolder)
                    }
                    if (data?.files) {
                        setFiles(data?.files)
                    }
                    let currentFolder = null;
                    let newPath = [...pathBreadCrumb]
                    currentFolder = routeParams.id ? newPath.findIndex((item) => item.id === routeParams.id) : 0;
                    if (currentFolder > 0) {
                        newPath = newPath.slice(0, currentFolder + 1);
                    } else {
                        if(data?.parent){
                            const parentFilter = newPath.filter((path) => path.id === data?.parent?.id);
                            if(parentFilter.length === 0){
                                newPath = [...newPath, data?.parent]
                            }
                        }
                        newPath = [...newPath, data]
                    }
                    setPathBreadCrumb(newPath)
                })
            } else {
                setFiles([]);
                setFolders([]);
            }
        } catch (error) {

        }

    }

    useEffect(() => {
        if (!routeParams.id) {
            getAllList()
        } else {
            getFilteredList()
        }
    }, [routeParams.id,selectedFileFolder])

    useEffect(() => {
        if(deletedFileFolder){
            if (!routeParams.id) {
                getAllList()
            } else {
                getFilteredList()
            }
        }
    },[deletedFileFolder])
    
    return (
        <PathBreadCrumbContext.Provider value={[pathBreadCrumb, setPathBreadCrumb]}>
            <FileFolderContext.Provider value={[selectedFileFolder, setSelectedFileFolder]} >
            <DeleteFileFolderContext.Provider value={[deletedFileFolder, setDeletedFileFolder]} >
                <FusePageCarded
                    content={<FileList folders={folders} files={files} deletedMsg={deletedFileFolder && deletedFileFolder} />}
                    rightSidebarOpen={selectedFileFolder && true}
                    rightSidebarContent={<DetailSidebarContent />}
                    rightSidebarWidth={400}
                    scroll={isMobile ? 'normal' : 'content'}
                />
            </DeleteFileFolderContext.Provider>
            </FileFolderContext.Provider>
        </PathBreadCrumbContext.Provider>
    );
}

export default HrPolicies
export { FileFolderContext, PathBreadCrumbContext, DeleteFileFolderContext }